const PDF_SIGNATURE = [0x25, 0x50, 0x44, 0x46, 0x2d];
const JPEG_SIGNATURE = [0xff, 0xd8, 0xff];
const PNG_SIGNATURE = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];

const hasPrefix = (bytes, signature) =>
  signature.every((value, index) => bytes[index] === value);

const normalizedContentType = (contentType) =>
  String(contentType || "").split(";", 1)[0].trim().toLowerCase();

export async function documentPreviewIssue(blob, fileName, contentType) {
  const type = normalizedContentType(contentType);
  const name = String(fileName || "").toLowerCase();
  const isPdf = type === "application/pdf" || name.endsWith(".pdf");
  const isJpeg = type === "image/jpeg" || /\.jpe?g$/.test(name);
  const isPng = type === "image/png" || name.endsWith(".png");

  if (!isPdf && !isJpeg && !isPng) return null;

  const bytes = new Uint8Array(await blob.slice(0, 16).arrayBuffer());
  if (isPdf && !hasPrefix(bytes, PDF_SIGNATURE)) {
    return "This attachment is not a valid PDF. Download it if needed, then replace it with a valid PDF.";
  }
  if (isJpeg && !hasPrefix(bytes, JPEG_SIGNATURE)) {
    return "This attachment is not a valid JPEG image. Download it if needed, then replace it with a valid JPEG image.";
  }
  if (isPng && !hasPrefix(bytes, PNG_SIGNATURE)) {
    return "This attachment is not a valid PNG image. Download it if needed, then replace it with a valid PNG image.";
  }
  return null;
}